import { mountVueComponent } from "@/lib/mount-vue-component";

export default function() {
  import('@/modules/clear/component/PasswordForm.vue').then(PasswordForm => {
    mountVueComponent('password-form', PasswordForm);
  });
};
